"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSourceLabel = exports.parseTicketQRCode = void 0;
const ticket_1 = require("../types/ticket");
/**
 * Parses a ticket QR code string into its component parts.
 * Supports formats:
 * - `{uuid}.{secret}`
 * - `{uuid}.{secret}.{source}`
 * - `{uuid}.{secret}.{source}.{base36-timestamp}`
 * - `{uuid}.{secret}.{source}.{base36-timestamp}.{fingerprintId}`
 */
const parseTicketQRCode = (data) => {
    const parts = data.split('.');
    if (parts.length < 2) {
        console.info('[Scan] Invalid QR code format — expected at least 2 dot-separated parts:', data);
        return null;
    }
    const [ticketItemId, secret, codeSource, encodedTimestamp, fingerprintId] = parts;
    if (!ticketItemId || !secret) {
        console.info('[Scan] Invalid QR code — missing ticketItemId or secret', {
            data,
            ticketItemId,
            secret,
        });
        return null;
    }
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(ticketItemId)) {
        console.info('[Scan] Invalid QR code — ticketItemId is not a valid UUID', {
            data,
            ticketItemId,
            secret,
        });
        return null;
    }
    if (!/^[a-z0-9]+$/i.test(secret)) {
        console.info('[Scan] Invalid QR code — secret contains non-alphanumeric characters', {
            data,
            ticketItemId,
            secret,
        });
        return null;
    }
    const result = { ticketItemId, secret };
    if (codeSource) {
        if (!Object.values(ticket_1.TicketItemCodeSource).includes(codeSource)) {
            console.info('[Scan] Invalid QR code — unknown code source', { data, codeSource });
            return null;
        }
        result.codeSource = codeSource;
    }
    if (encodedTimestamp) {
        const timestamp = parseInt(encodedTimestamp, 36);
        if (isNaN(timestamp)) {
            console.info('[Scan] Invalid QR code — invalid timestamp', { data, encodedTimestamp });
            return null;
        }
        result.generatedAt = new Date(timestamp * 1000);
    }
    if (fingerprintId) {
        result.fingerprintId = fingerprintId;
    }
    return result;
};
exports.parseTicketQRCode = parseTicketQRCode;
/**
 * Display label for where a validation came from; MCP uses read "AI" (ENG-4548).
 */
const validationSourceLabel = (source) => {
    if (!source) {
        return '';
    }
    return source === ticket_1.TicketItemValidationSource.MCP ? 'AI' : source.toUpperCase();
};
exports.validationSourceLabel = validationSourceLabel;
